import { render, staticRenderFns } from "./delete-switcher.vue?vue&type=template&id=3d1a5b98&lang=pug"
import script from "./delete-switcher.vue?vue&type=script&lang=js"
export * from "./delete-switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports